exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RateCost_rate-description_2H0g {\n  margin-top: 10px;\n\n  color: #787878;\n}\n\n.RateCost_rate-cost_GRjy {\n  white-space: nowrap;\n}\n\n@media (min-width: 768px) {\n\n  .RateCost_rate-cost_GRjy br {\n    display: none;\n  }\n}\n\n.RateCost_rate-date_1Ynd {\n  display: none;\n}\n\n@media (min-width: 768px) {\n\n  .RateCost_rate-date_1Ynd {\n    display: block;\n    white-space: nowrap;\n    color: #777;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"rate-description": "RateCost_rate-description_2H0g",
	"rate-cost": "RateCost_rate-cost_GRjy",
	"rate-date": "RateCost_rate-date_1Ynd"
};